<template>
  <t-form labelWidth="100px">
    <CptData :data="attribute.cptTableData" :cptDataForm="cptDataForm"/>
    <e-collapse title="标题" :expand="false">
      <t-form-item label="标题">
        <t-input size="small" v-model="attribute.title.text" :maxcharacter="52"/>
      </t-form-item>
      <t-form-item label="标题大小">
        <t-input-number size="small" v-model="attribute.title.textStyle.fontSize" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="标题颜色">
        <t-color-picker :colorModes="['monochrome']" format="HEX" size="small" v-model="attribute.title.textStyle.color"/>
      </t-form-item>
      <t-form-item label="标题位置(X)">
        <e-chart-position v-model="attribute.title.left" :direction="'x'"/>
      </t-form-item>
      <t-form-item label="标题位置(Y)">
        <e-chart-position v-model="attribute.title.top" :direction="'y'"/>
      </t-form-item>
    </e-collapse>
    <e-collapse title="图例" :expand="false">
      <t-form-item label="图例显示">
        <t-switch v-model="attribute.legend.show" :label="['开', '关']" size="small"/>
      </t-form-item>
      <t-form-item label="图例位置(X)">
        <e-chart-position v-model="attribute.legend.left" :direction="'x'"/>
      </t-form-item>
      <t-form-item label="图例位置(Y)">
        <e-chart-position v-model="attribute.legend.top" :direction="'y'"/>
      </t-form-item>
      <t-form-item label="图例布局方式">
        <t-radio-group v-model="attribute.legend.orient" size="small">
          <t-radio-button value="vertical">纵向</t-radio-button>
          <t-radio-button value="horizontal">横向</t-radio-button>
        </t-radio-group>
      </t-form-item>
      <t-form-item label="图例字体">
        <t-input-number size="small" v-model="attribute.legend.textStyle.fontSize" :min="2" :max="120" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="图例文字颜色">
        <t-color-picker :colorModes="['monochrome']" format="HEX" size="small" v-model="attribute.legend.textStyle.color"/>
      </t-form-item>
    </e-collapse>
    <e-collapse title="内边距" :expand="false">
      <t-form-item label="内边距(左)">
        <t-input-number size="small" v-model="attribute.series.left" :min="0" :max="200" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="内边距(上)">
        <t-input-number size="small" v-model="attribute.series.top" :min="0" :max="200" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="内边距(右)">
        <t-input-number size="small" v-model="attribute.series.right" :min="0" :max="200" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="内边距(下)">
        <t-input-number size="small" v-model="attribute.series.bottom" :min="0" :max="200" :decimal-places="0"/>
      </t-form-item>
    </e-collapse>
    <e-collapse title="标签" :expand="false">
      <t-form-item label="显示">
        <t-switch v-model="attribute.series.label.show" :label="['开', '关']" size="small"/>
      </t-form-item>
      <t-form-item label="字体">
        <t-input-number v-model="attribute.series.label.fontSize" :min="2" :max="100" size="small" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="颜色" v-show="attribute.series.label.color">
        <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.series.label.color" size="small"/>
      </t-form-item>
      <t-form-item label="位置" v-show="attribute.series.label.position">
        <t-select v-model="attribute.series.label.position" size="small">
          <t-option label="顶部" value="top"/>
          <t-option label="左侧" value="left"/>
          <t-option label="右侧" value="right"/>
          <t-option label="底部" value="bottom"/>
          <t-option label="中心" value="inside"/>
          <t-option label="内部左侧" value="insideLeft"/>
          <t-option label="内部右侧" value="insideRight"/>
          <t-option label="左上" value="leftTop"/>
          <t-option label="左下" value="leftBottom"/>
          <t-option label="右上" value="rightTop"/>
          <t-option label="右下" value="rightBottom"/>
        </t-select>
      </t-form-item>
      <t-form-item>
        <template slot="label">
          连接线显示
          <t-tooltip content="标签位置在外部时显示连接线" :overlay-style="{ width: '200px' }" placement="top-right" show-arrow>
            <t-icon name="info-circle"/>
          </t-tooltip>
        </template>
        <t-switch v-model="attribute.series.labelLine.show" :label="['开', '关']" size="small"/>
      </t-form-item>
      <t-form-item label="连接线长度">
        <t-input-number size="small" v-model="attribute.series.labelLine.length" :min="10" :max="500" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="连接线粗细">
        <t-input-number size="small" v-model="attribute.series.labelLine.lineStyle.width" :min="1" :max="10" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="连接线样式">
        <t-select v-model="attribute.series.labelLine.lineStyle.type" size="small">
          <t-option label="直线" value="solid"/>
          <t-option label="虚线" value="dashed"/>
          <t-option label="dotted" value="dotted"/>
        </t-select>
      </t-form-item>
    </e-collapse>
    
    <t-form-item label="图布局方式">
      <t-radio-group v-model="attribute.series.orient" size="small">
        <t-radio-button value="vertical">纵向</t-radio-button>
        <t-radio-button value="horizontal">横向</t-radio-button>
      </t-radio-group>
    </t-form-item>
    <t-form-item label="间距">
      <t-input-number size="small" v-model="attribute.series.gap" :decimal-places="0"/>
    </t-form-item>
    <t-form-item label="对齐方式">
      <t-radio-group v-model="attribute.series.funnelAlign" size="small">
        <t-radio-button value="left">靠左</t-radio-button>
        <t-radio-button value="center">居中</t-radio-button>
        <t-radio-button value="right">靠右</t-radio-button>
      </t-radio-group>
    </t-form-item>
    <t-form-item label="排序">
      <t-radio-group v-model="attribute.series.sort" size="small">
        <t-radio-button value="ascending">升序</t-radio-button>
        <t-radio-button value="descending">降序</t-radio-button>
        <t-radio-button value="none">不排序</t-radio-button>
      </t-radio-group>
    </t-form-item>
    <t-form-item label="配色">
      <e-color-group v-model="attribute.color" :max="20" :gradient="false"/>
    </t-form-item>
  </t-form>
</template>

<script>
import EChartPosition from "@/components/designer/e-chart-position";
import EColorGroup from "@/components/designer/e-color-group";
import CptData from '@/components/element/options/comp/cpt-data'
export default {
  name: "cpt-chart-funnel-option",
  components: {EColorGroup, EChartPosition,CptData},
  props: { attribute: Object,cptDataForm:Object, },
}
</script>

<style scoped>
.colorBlock{float: left; width: 25px;height: 25px;margin-right: 2px;}
.colorBlock:hover .delTag{display: inline-block}
.delTag{width: 100%;height: 100%;display: none;text-align: center;font-size: 18px;color: #fff}
</style>
